import { PATHS } from '@client/routes';

type PageKey =
  | 'home'
  | 'profile'
  | 'library'
  | 'marketing'
  | 'promotions'
  | 'crm'
  | 'inbox'
  | 'extras'
  | 'offers'
  | 'subscription'
  | 'subscriptions'
  | 'otps'
  | 'new-otp'
  | 'programs'
  | 'community'
  | 'payouts';

export const getPagePath = (
  key: string,
  influencerId: number,
): string | null => {
  const map: Record<PageKey, string> = {
    home: PATHS.HOME,
    profile: PATHS.PARTNER_EDIT(influencerId),
    library: PATHS.LIBRARY(influencerId),
    marketing: PATHS.MARKETING(influencerId),
    promotions: PATHS.PROMOTIONS(influencerId),
    crm: PATHS.CRM_CREATOR(influencerId, 'users'),
    inbox: PATHS.INBOX_MESSAGE(influencerId),
    extras: PATHS.EXTRAS(influencerId),
    offers: PATHS.BUNDLES(influencerId),
    subscription: PATHS.SUBSCRIPTIONS(influencerId),
    subscriptions: PATHS.SUBSCRIPTIONS(influencerId),
    otps: PATHS.PURCHASES(influencerId),
    'new-otp': PATHS.NEW_PROGRAM(influencerId, { salesType: 'otp' }),
    programs: PATHS.PROGRAMS(influencerId),
    community: PATHS.CREATOR_COMMUNITIES(influencerId),
    payouts: PATHS.ADMIN_PAYMENT(influencerId),
  };

  return map[key as PageKey] ?? null;
};
